module.exports = __webpack_public_path__ + "img/programmer-and-coding-concept.cab352e0.webp";